import styled from "styled-components"

export const StyledFoodDetails = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

export const FoodDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  padding: 0 var(--app-horizontal-padding);
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 1000;
  justify-content: space-between;
  
  svg {
    cursor: pointer;
  }
`

export const FoodDetailsContent = styled.div`
  height: calc(100% - var(--app-cta-height));
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

export const FoodDetailsInfo = styled.div`
  padding: 0 var(--app-horizontal-padding);
  padding-bottom: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;

  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`

export const ScanResultInfoBox = styled.div`
  padding: 12px;
  display: flex;
  gap: 4px;

  box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);
  border-radius: var(--card_corner, 8px);
  border: 1px solid var(--Schemes-Primary-Container-Variant-2, #0fbdd4);
  background: #e0fdff;
`

export const InfoIconBox = styled.div`
  display: flex;
  width: 34px;
  height: 34px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  border-radius: 50%;
  background: var(--Primitive-White, #fff);
`

export const BarcodeResultInfoContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const FoodResultName = styled.p`
  margin: 0;
  line-height: 160%;
`

export const FindBetterMatch = styled.div`
  font-weight: 600;
  line-height: 160%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
  color: var(--Schemes-Primary-Container-Variant-2, #0fbdd4);
`
